/* eslint-disable react-hooks/exhaustive-deps */

import { removeNullAnalyticValues } from 'listing-details/helpers';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { trackPage } from 'shared/helpers/trackPage';
import { ListingContactPageTrackingProps } from './useListingContactPageTracking.types';

export const useListingContactPageTracking = (
    data: ListingContactPageTrackingProps
): void => {
    const { query } = useRouter();
    const page = `/${data.listing.section}/contact/`;

    const ecommerce = {
        checkout: {
            products: [
                removeNullAnalyticValues(data.listing.analyticsEcommerce)
            ]
        }
    };

    const taxonomy = removeNullAnalyticValues({
        activity: 'listing_contact',
        page,
        url: data.listing.listingUris.contact,
        search_identifier: (query['search_identifier'] as string) || null,
        ...data.listing.analyticsTaxonomy
    });

    useEffect(() => {
        trackPage(page, taxonomy, ecommerce);
    }, [data.listing.analyticsTaxonomy.listingId]);
};
